export default "__VITE_ASSET__af9ae414__"